import React, { Suspense, lazy } from 'react';
import { Route, Switch } from 'react-router-dom';
import PermissionGuard2 from '../../../../Layout/PermissionGuard2';
import LoadingOverlay from 'react-loading-overlay';
LoadingOverlay.propTypes = undefined;

// Loading component
function Loading() {
  return (
    <>
      <div className="wrapper">
        <span>Loading</span>
      </div>
    </>
  );
}

// Import pages
const TransactionList = lazy(() => import('../Pages/TransactionList'));
const AddTransaction = lazy(() => import('../Pages/AddTransaction'));
const EditTransaction = lazy(() => import('../Pages/EditTransaction'));
const TransactionView = lazy(() => import('../Pages/TransactionView'));
const SupplierLedger = lazy(() => import('../Pages/SupplierLedger'));

/**
 * TransactionRoute component
 * Defines all routes related to the Transaction module
 */
const TransactionRoute = ({ match }) => {
  const { path } = match;
  return (
    <Switch>
      <Route
        exact
        path={`${path}`}
        render={(routeProps) => (
          <React.Fragment>
            <Suspense fallback={<Loading />}>
              <TransactionList />
            </Suspense>
          </React.Fragment>
        )}
      />
      <Route
        exact
        path={`${path}/add`}
        render={(routeProps) => (
          <React.Fragment>
            <Suspense fallback={<Loading />}>
              <AddTransaction />
            </Suspense>
          </React.Fragment>
        )}
      />
      <Route
        exact
        path={`${path}/edit/:slack`}
        render={(routeProps) => (
          <React.Fragment>
            <Suspense fallback={<Loading />}>
              <EditTransaction isEdit={true} />
            </Suspense>
          </React.Fragment>
        )}
      />
      <Route
        exact
        path={`${path}/view/:slack`}
        render={(routeProps) => (
          <React.Fragment>
            <Suspense fallback={<Loading />}>
              <TransactionView />
            </Suspense>
          </React.Fragment>
        )}
      />
      <Route
        exact
        path={`${path}/supplier-ledger`}
        render={(routeProps) => (
          <React.Fragment>
            <Suspense fallback={<Loading />}>
              <SupplierLedger />
            </Suspense>
          </React.Fragment>
        )}
      />
    </Switch>
  )
};

export default TransactionRoute;
